angular.module('leanlaw').directive('timeBar', ["$document", "$window", function ($document, $window) {
  return {
    restrict: 'A',
    scope: {
      resolution: "="
    },
    template: require('./views/timeBar.html'),
    link: function ($scope, element, attrs, ctrl) {
      // Preload 12AM
      $scope.times = [{
        time: 12,
        median: "AM"
      }];

      // Load the remaining hours
      for (var i = 0; i < 23; i++) {
        $scope.times.push({
          time: i < 12 ? i + 1 : i - 11,
          median: i < 11 ? "AM" : "PM"
        });
      }

      // Moves times to their appropriate positions
      var repositionTimes = function (spacing) {
        var timeGroups = element[0].querySelectorAll(".time-group");
        for (var i = 0; i < timeGroups.length; i++) {
          timeGroups[i].style.top = i * spacing + "px";
          timeGroups[i].style.height = spacing + "px";
        }
      };
      $scope.$watch("resolution", function (newValue) {
        repositionTimes($scope.resolution * 10);
      });
    }
  };
}]);